import Vue from 'vue';
import Vuex from 'vuex';

// Import globally used stores
import AuthStore from '@/infrastructure/auth/store';
import BlogStore from '@/taskflex/blog/store';
import ContactFormStore from '@/taskflex/students/store/contactForm';
import SkillsStore from '@/taskflex/skills/store';
import LevelsStore from '@/taskflex/levels/store';
import ConversationsStore from '@/taskflex/conversations/store';
import StudentsStore from '@/taskflex/students/store/students';

import FileUploadsStore from '@/infrastructure/fileuploads/store';

Vue.use(Vuex);

const store = new Vuex.Store({
    // Add global stuff to store here
});

// Register globally used stores
store.registerModule('auth', AuthStore);
store.registerModule('blog', BlogStore);
store.registerModule('contactForm', ContactFormStore);
store.registerModule('skills', SkillsStore);
store.registerModule('levels', LevelsStore);
store.registerModule('conversations', ConversationsStore);
store.registerModule('students', StudentsStore);

store.registerModule('fileuploads', FileUploadsStore);

export default store;



// WEBPACK FOOTER //
// ./src/services/StoreService.js